( function( $, document, window ) {
	'use strict';

	$( function() {
        let swiper;

        const handleResize = () => {
            if ( window.matchMedia( '(max-width: 1023px)' ).matches ) {
                if ( ! swiper ) {
                    swiper = new Swiper( '.js-featured-posts', {
                        direction: 'horizontal',
                        slidesPerView: 1.125,
                        spaceBetween: 20,
                        loop: true,
                        grabCursor: true,

                        breakpoints: {
                            767: {
                                slidesPerView: 2.25,
                            }
                        }
                    } );
                }
            } else {
                if ( swiper ) {
                    swiper.destroy();
                    swiper = null;
                }
            }
        }

        handleResize();

        $( window ).on( 'resize', () => {
            debounce( handleResize, 300 );
        } );
	} );
} )( jQuery, document, window );
